import { z } from "zod";

export const UploadSchema = z.object({
  id: z.string(),
  file_key: z.string(),
  file_url: z.string(),
  modified_filename: z.string(),
  original_filename: z.string(),
  content_type: z.string(),
  file_size: z.number(),
  source_url: z.string().nullable(),
  folder: z.string(),
  is_active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
});

export type Upload = z.infer<typeof UploadSchema>;
